import { render, staticRenderFns } from "./QuaggaMicha.vue?vue&type=template&id=51092522&"
import script from "./QuaggaMicha.vue?vue&type=script&lang=js&"
export * from "./QuaggaMicha.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports